import { onBeforeRouteLeave } from "vue-router";

export default function () {
  const isChange = ref(false);

  function confirmSave(e: BeforeUnloadEvent) {
    if (isChange.value) {
      e.preventDefault();
      e.returnValue = "";
    }
  }

  onBeforeMount(() => {
    window.addEventListener("beforeunload", confirmSave);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("beforeunload", confirmSave);
  });

  onBeforeRouteLeave(() => {
    if (isChange.value) {
      if (
        !confirm(
          "このページから移動しますか？ 変更が保存されない可能性があります。",
        )
      ) {
        return false;
      }
    }
  });

  return {
    isChange,
  };
}
